module.exports = __webpack_public_path__ + "img/logo_5.7c768e79.png";